const en_whs_returncus = {
    "": "customer return",
    detail: "customer return detail",
}

export default en_whs_returncus;